export default __webpack_public_path__ + "static/media/certificateImg.aa8a13c6.svg";